export default "__VITE_ASSET__1d8ca66b__"